export default __webpack_public_path__ + "static/media/s9.1b202663.png";